export const formatShiftDistributionStr = (
  dayShifts: number | null,
  eveShifts: number | null,
  nightShifts: number | null
) => {
  if (dayShifts === null || eveShifts === null || nightShifts === null) {
    return 'Not Provided';
  }
  return `${dayShifts + eveShifts + nightShifts} (${dayShifts} Day, ${eveShifts} Evening, ${nightShifts} Night)`;
};

type DifferentialRow = {
  count: keyof JobListingDetail;
  differential: keyof JobListingDetail;
};

const SHIFT_DIFFERENTIAL_ROWS: DifferentialRow[] = [
  { count: 'numEveShifts', differential: 'eveShiftRateDiff' },
  { count: 'numNightShifts', differential: 'nightShiftRateDiff' },
  { count: 'numOfWeDayShifts', differential: 'weDayShiftRateDiff' },
  { count: 'numOfWeEveShifts', differential: 'weEveShiftRateDiff' },
  { count: 'numOfWeNightShifts', differential: 'weNightShiftRateDiff' },
  { count: 'numHolDayShifts', differential: 'holDayShiftRateDiff' },
  { count: 'numHolEveShifts', differential: 'holEveShiftRateDiff' },
  { count: 'numHolNightShifts', differential: 'holNightShiftRateDiff' },
];

const CALL_DIFFERENTIAL_ROWS: DifferentialRow[] = [
  { count: 'numDayCallShifts', differential: 'dayCallShiftRateDiff' },
  { count: 'numEveCallShifts', differential: 'eveCallShiftRateDiff' },
  { count: 'numNightCallShifts', differential: 'nightCallShiftRateDiff' },
  { count: 'numOfWeDayCallShifts', differential: 'weDayCallShiftRateDiff' },
  { count: 'numOfWeEveCallShifts', differential: 'weEveCallShiftRateDiff' },
  { count: 'numOfWeNightCallShifts', differential: 'weNightCallShiftRateDiff' },
  { count: 'numHolDayCallShifts', differential: 'holDayCallShiftRateDiff' },
  { count: 'numHolEveCallShifts', differential: 'holEveCallShiftRateDiff' },
  { count: 'numHolNightCallShifts', differential: 'holNightCallShiftRateDiff' },
];

const calculateDifferentialTotal = (
  detail: JobListingDetail,
  rows: DifferentialRow[],
  differentialType: ShiftDifferentialType | null
): number => {
  const baseRate = Number(detail.pricePerHour ?? 0);
  const hoursPerShift = Number(detail.hoursPerShift ?? 0);

  return rows.reduce((total, row) => {
    const count = Number(detail[row.count] ?? 0);
    const differential = Number(detail[row.differential] ?? 0);
    const effectiveRate = calculateCostPerHour(detail, differential, differentialType);
    return total + Math.max(effectiveRate - baseRate, 0) * hoursPerShift * count;
  }, 0);
};

export const calculateLocalDifferentialTotals = (detail: JobListingDetail) => ({
  shift: calculateDifferentialTotal(detail, SHIFT_DIFFERENTIAL_ROWS, detail.shiftDiffType),
  call: calculateDifferentialTotal(detail, CALL_DIFFERENTIAL_ROWS, detail.callShiftDiffType),
});
import { ShiftDifferentialType } from '~/types/hlx/enums';
import { JobListingDetail } from '~/types/hlx/jobListingDetail';
import { calculateCostPerHour } from '../cost-calculator/utils';
